import type {RouteRecordRaw} from 'vue-router';
import {pagesPath} from '@/ts/router/pages-path';
import PublicSignUpPage from '@/vue/pages/public/public-sign-up-page.vue';
import PublicVerifyEmailPage from '@/vue/pages/public/public-verify-email-page.vue';
import PublicSignInRedirectPage from '@/vue/pages/public/public-sign-in-redirect-page.vue';
import PublicContinueAuthPage from '@/vue/pages/public/public-continue-auth-page.vue';
import NotFoundPage from '@/vue/pages/not-found-page.vue';
import PrivacyPolicyPage from '@/vue/pages/privacy-policy-page.vue';
import InstructionsForUsePage from '@/vue/pages/instructions-for-use-page.vue';

/**
 * Route definitions for unauthenticated public pages (sign-up, sign-in, privacy policy, 404).
 *
 * The `page_title_*` keys duplicate the copy of `sign_up` and `log_in` today, and keep their own
 * keys on purpose: a tab title is free to diverge from the button that shares its wording.
 */
export const publicPages: RouteRecordRaw[] = [
  {
    path: pagesPath.public.signUp,
    component: PublicSignUpPage,
    meta: {
      titleKey: 'page_title_sign_up',
      medicalDevice: false,
    },
  },
  {
    path: pagesPath.public.public,
    redirect: pagesPath.public.signUp,
  },
  {
    path: pagesPath.public.verifyEmail,
    component: PublicVerifyEmailPage,
    meta: {
      titleKey: 'page_title_verify_email',
      medicalDevice: false,
    },
  },
  {
    path: pagesPath.public.signInRedirect,
    component: PublicSignInRedirectPage,
    meta: {
      titleKey: 'page_title_sign_in',
      medicalDevice: false,
    },
  },
  {
    path: pagesPath.public.continueAuth,
    component: PublicContinueAuthPage,
    meta: {
      medicalDevice: false,
    },
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicyPage,
    meta: {
      medicalDevice: false,
    },
  },
  {
    path: pagesPath.public.instructionsForUse,
    component: InstructionsForUsePage,
    meta: {
      medicalDevice: true,
    },
  },
  {
    path: '/:catchAll(.*)',
    component: NotFoundPage,
    meta: {
      disablePageScrollingInTemplate: true,
      medicalDevice: false,
    },
  },
];
